import React from 'react'
import Autocomplete from 'react-autocomplete'
import * as S from './styles'

type Props = {
  options:Array<ObjProps>
  labelColor:string
  name:string
  label:string
  isRequired?:boolean
  onMenuOpen?:any
  onSelect?:any
  value:string
  setValue:any
}
type ObjProps={
  cd:string
  nome:string
}

const MyAutoComplete = ({
  options, labelColor, name, label, isRequired, onMenuOpen, onSelect, value, setValue,
}:Props) => (
  <S.Wrapper className="input">
    <label style={{ color: labelColor }} htmlFor={name}>
      {label}
    </label>
    <Autocomplete
      inputProps={{
        required: isRequired,
      }}
      items={options}
      shouldItemRender={(item, val) => item.nome.toLowerCase().indexOf(val.toLowerCase()) > -1}
      getItemValue={(item) => item.nome}
      menuStyle={S.MenuStyle}
      wrapperStyle={S.WrapperAutocomplete}
      renderItem={(item, highlighted) => (
        <div
          key={item.cd}
          style={{
            backgroundColor: highlighted ? '#eee' : 'transparent',
            ...S.MenuItemStyle,
          }}
        >
          {item.nome}
        </div>
      )}
      onMenuVisibilityChange={onMenuOpen}
      value={value}
      onChange={(e:any) => {
        setValue(e.target.value)
        onSelect(e.target.value)
      }}
      onSelect={(val, item) => {
        onSelect(item.cd)
        setValue(val)
      }}
      selectOnBlur
      autoHighlight
    />
  </S.Wrapper>
)
export default MyAutoComplete
